import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, TransitionGroup, Transition, markRaw } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'transition-fade',
  props: {
    name: { default: "fade" },
    mode: { default: "default" },
    isGroup: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const component = computed(() => (props.isGroup ? markRaw(TransitionGroup) : markRaw(Transition)));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(component.value), {
    name: _ctx.name,
    mode: _ctx.mode
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["name", "mode"]))
}
}

})